import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { GetLanguage, SetLanguage } from "@/shared/services/credentialsService";
import { switchLanguage } from "@/features/languages";

export default function LanguageToggle() {
  const dispatch = useDispatch();
  const [selectedLang, setSelectedLang] = useState("es");

  const languages = {
    en: {
      name: "English",
      svg: (
        <svg width="50" height="16" viewBox="0 0 50 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="49" height="15" rx="7.5" fill="white" stroke="#939598"/>
          <path d="M27.792 12V4.168H33.567V5.642H29.574V7.369H33.27V8.656H29.574V10.526H33.677V12H27.792ZM38.0278 12.209C35.9048 12.209 34.5518 11.098 34.5408 9.426H36.2788C36.2898 10.284 36.9388 10.823 38.0828 10.823C39.0288 10.823 39.5898 10.449 39.5898 9.822C39.5898 9.074 38.7868 8.92 37.8518 8.777C36.4768 8.579 34.6178 8.337 34.6178 6.445C34.6178 4.938 35.8608 3.959 37.8628 3.959C39.8868 3.959 41.1848 5.037 41.1848 6.676H39.5018C39.5128 5.829 38.8968 5.345 37.9068 5.345C36.9828 5.345 36.4438 5.73 36.4438 6.313C36.4438 7.072 37.3238 7.204 38.3138 7.347C39.6888 7.556 41.4158 7.853 41.4158 9.712C41.4158 11.23 40.1068 12.209 38.0278 12.209Z" fill="black"/>
          <circle cx="8" cy="8" r="6" fill="black"/>
        </svg>
      )
    },
    es: {
      name: "Español", 
      svg: (
        <svg width="50" height="16" viewBox="0 0 50 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="49" height="15" rx="7.5" fill="white" stroke="#939598"/>
          <path d="M27.792 12V4.168H33.567V5.642H29.574V7.369H33.27V8.656H29.574V10.526H33.677V12H27.792ZM34.8818 12V4.168H36.9938L39.9638 9.635H40.0738V4.168H41.8118V12H39.6998L36.7298 6.544H36.6198V12H34.8818Z" fill="black"/>
          <circle cx="8" cy="8" r="6" fill="black"/>
        </svg>
      )
    }
  };

  useEffect(() => {
    const lang = GetLanguage() || "es";
    dispatch(switchLanguage(lang));
    SetLanguage(lang);
    setSelectedLang(lang);
  }, [dispatch]);

  const toggleLanguage = () => {
    const newLang = selectedLang === "en" ? "es" : "en";
    dispatch(switchLanguage(newLang));
    SetLanguage(newLang);
    setSelectedLang(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center justify-center p-1 bg-transparent hover:opacity-80 transition-opacity cursor-pointer -ml-6"
      aria-label={`Switch to ${selectedLang === "en" ? "Español" : "English"}`}
      title={`Current: ${languages[selectedLang].name} - Click to switch`}
    >
      {languages[selectedLang].svg}
    </button>
  );
}